import { useTranslation } from 'react-i18next';
import { ConfirmActionModal } from '@/components/patient/PatientTabActions';
import type { DocumentRow } from '@/hooks/useDocuments';

export function DeletePatientFileDialog({
  doc,
  pending,
  onClose,
  onConfirm,
}: {
  doc: DocumentRow;
  pending?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  const { t } = useTranslation();
  return (
    <ConfirmActionModal
      open
      title={t('patients.files.delete_title')}
      description={t('patients.files.delete_confirm', { name: doc.original_filename })}
      confirmLabel={t('patients.files.delete')}
      pending={pending}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
